const iconStyle = {
  size: '20px',
  color: '#394563',
  colorActive: '#ffffff',
}

export { iconStyle }
